import React from 'react';

import styles from './index.module.scss';

const LandingPage = () => (
  <div className={styles.landing}>
    <p>This is mobile app - You can see only object details.</p>
    <p>Landing page is available only on touch app</p>
  </div>
);

export default LandingPage;
